import React, { useCallback, useEffect } from 'react';

//Hooks
import {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { useHistory, Redirect, useParams } from 'react-router-dom';
import {useTranslation} from "react-i18next";

//Actions
import * as actions from '../../../../store/actions';

//Components
import {Button, Container} from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import WeekPicker from "../../../../components/WeekPicker/WeekPicker";
import FiltersModal from "./FiltersModal";
import DaysFilter from '../../../../components/DaysFilter';

//Styles
import Styles from './Groups.module.scss';

//Utils
import moment from 'moment';
import ServiceOptions from "../../../../components/ServiceOptions/ServiceOptions";
import ScreenFooter from "../../../../components/ScreenFooter/ScreenFooter";
import Icon from "../../../../components/Icon/Icon";

import { ROUTER_URL } from '../../../../const/ROUTER_URL';

const Groups = () => {
    const { shopId } = useParams();
    const groups = useSelector(state => state.groups.groups && state.groups.groups
        .map(({date, groups}) => ({
            date,
            groups: groups.filter(group => group.bookable_type !== 'never_and_hidden')
        }))
        .filter(({groups}) => groups.length !== 0)
    );
    const selectedGroupID = useSelector(state => state.groups.selectedGroupID);
    const {groups: showGroups} = useSelector(state => state.companies.shop ? state.companies.shop.products : {});
    const dispatch = useDispatch();
    const style = useSelector(state => state.widget.style);
    const { groupFilterOptions, activeFilters, tintColor } = useSelector(({ companies }) => companies);
    const { daysFilterApplied } = useSelector(({ groups }) => groups);
    const daysFilter = React.useRef(null);

    const history = useHistory();
    const {t} = useTranslation('common');

    const [date, setDate] = useState(moment().startOf('isoWeek'));
    const [loadingGroups, setLoadingGroups] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [fillButton, setFillButton] = useState(false);

    const handleBookConfirmRedirect = useCallback(() => {
        history.push(ROUTER_URL.BOOK_CONFIRM_GROUP);
    }, [history]);

    useEffect(() => {
        dispatch(actions.selectService(null));
        dispatch(actions.selectBundle(null));
        dispatch(actions.selectEvent(null));
    }, [dispatch]);

    useEffect(() => {
        dispatch(actions.getGroups(
            date.clone().locale('en').isoWeek(),
            date.clone().locale('en').isoWeekYear())
        );
    }, [date, dispatch]);

    useEffect(/* istanbul ignore next */ () => {
        if (loadingGroups || !showGroups || !groups || groups.reduce((all, {groups}) => [...all, ...groups], []).length !== 0) {
            if(groups && groups.reduce((all, {groups}) => [...all, ...groups], []).length !== 0) {
                setLoadingGroups(false);
            }
            return;
        }

        // setDate(date => date.clone().add(1, 'week'));
        setLoadingGroups(true);
    }, [showGroups, groups, loadingGroups]);

    const clearDaysFilter = useCallback(() => {
        dispatch(actions.setDateFilter('', false));
        dispatch(actions.getGroups(
            date.clone().locale('en').isoWeek(),
            date.clone().locale('en').isoWeekYear()
        ));
    }, [dispatch, date]);

    const onDaySelect = useCallback((day) => {
        dispatch(actions.setDateFilter(day));
        dispatch(actions.getGroups(
            date.clone().locale('en').isoWeek(),
            date.clone().locale('en').isoWeekYear()
        ));
    }, [dispatch, date]);

    const toggleDaysFilter = useCallback(() => {
        if (daysFilterApplied) {
            return clearDaysFilter();
        }
        const today = moment().startOf('day');
        const weekStart = today.clone().startOf('isoWeek');
        setDate(weekStart);
        dispatch(actions.setDateFilter(today.format('Y M D')));
        dispatch(actions.getGroups(
            today.clone().locale('en').isoWeek(),
            today.clone().locale('en').isoWeekYear()
        ));
    }, [daysFilterApplied, clearDaysFilter, dispatch]);

    if (!showGroups) {
        return (
            <Redirect
                to={ROUTER_URL.SHOPS_ID_EVENTS({ shopId })}
                exact
            />
        );
    }

    const onWeekChange = (direction) => () => {
        if (direction === 'left') {
            const newDate = date.clone().subtract(1, 'week');
            setDate(newDate);

            if (daysFilterApplied) {
                dispatch(actions.setDateFilter(newDate.format('Y M D')));
            }
        } else {
            const newDate = date.clone().add(1, 'week');
            setDate(newDate);

            if (daysFilterApplied) {
                dispatch(actions.setDateFilter(newDate.format('Y M D')));
            }
        }
    };

    const clearFilters = () => {
        const defaultFilters = {
            employees: [],
            services: [],
            objects: [],
        };

        setFillButton(false);
        dispatch(actions.setActiveFilters(defaultFilters));
        dispatch(actions.getGroups(
            date.clone().locale('en').isoWeek(),
            date.clone().locale('en').isoWeekYear()
        ));
        setShowModal(false);
    }

    const applyFilters = () => {
        setFillButton(true);
        dispatch(actions.setActiveFilters(activeFilters));
        dispatch(actions.getGroups(
            date.clone().locale('en').isoWeek(),
            date.clone().locale('en').isoWeekYear()
        ));
        setShowModal(false);
    }

    const toggleModal = () => {
        setShowModal(true);
    }

    return (
        <>
            <Container
                className={[
                    Styles.container,
                    'px-0',
                    (style === 'dev' || style === 'website') ? Styles.website : ''
                ].join(' ')}
                style={{paddingBottom: (style === 'dev' || style === 'website') && !!selectedGroupID ? '112px' : ''}}
            >
                <div className={Styles.openFiltersWrapper}>
                    <div className={Styles.buttonsWrapper}>
                        <button
                            className={Styles.openFiltersButton}
                            style={daysFilterApplied ? { backgroundColor: tintColor, color: '#fff', borderColor: tintColor } : { color: tintColor, borderColor: tintColor }}
                            onClick={toggleDaysFilter}
                        >
                            day
                        </button>
                    </div>
                    <div className={Styles.buttonsWrapper}>
                        <button
                            className={Styles.openFiltersButton}
                            style={fillButton ? { backgroundColor: tintColor, color: '#fff', borderColor: tintColor } : { color: tintColor, borderColor: tintColor }}
                            onClick={toggleModal}
                        >
                            filters
                        </button>
                    </div>
                </div>
                <WeekPicker
                    date={date}
                    onPressPrev={onWeekChange('left')}
                    onPressNext={onWeekChange('right')}
                />

                <DaysFilter
                    ref={daysFilter}
                    tintColor={tintColor}
                    onDaySelect={onDaySelect}
                    date={date}
                    week={date.clone().locale('en').isoWeek()}
                    t={t}
                />

                {!groups && (
                    <div className={Styles.centeredContainer}>
                        <Loader
                            type={'TailSpin'}
                            color={'#000'}
                            width={48}
                            height={48}
                        />
                    </div>
                )}

                {groups && (
                    <div className="px-4 flex-grow-1 w-100 h-100">
                        {groups.length !== 0 && (
                            <div className={'w-100'}>
                                {groups.map(({date, groups}) => <Day key={`day-${date.dayOfYear()}-${date.isoWeekYear()}`}
                                                                     date={date} groups={groups}/>)}
                            </div>
                        )}

                        {groups.length === 0 && (
                            <div className={'d-flex flex-column justify-content-center align-items-center py-5 my-5'}>
                                <Icon name='calendar' size={58} color='#B3BDC8'/>
                                <p className={'text-uppercase font-weight-bold mt-2'} style={{color: '#B3BDC8'}}>{t('homeScreen.groupClasses.noGroups')}</p>
                            </div>
                        )}
                    </div>
                )}
            </Container>

            <ScreenFooter visible={!!selectedGroupID}>
                <Button
                    variant={'tint'}
                    size={'lg'}
                    className={Styles.bookButton}
                    onClick={handleBookConfirmRedirect}
                    data-testid='data-test-group-book-button'
                >
                    {t('homeScreen.makeABooking')}
                </Button>
            </ScreenFooter>
            {showModal && (
                <FiltersModal
                    onClear={clearFilters}
                    onApply={applyFilters}
                    onClose={() => setShowModal(false)}
                    tintColor={tintColor}
                    filterOptions={groupFilterOptions}
                    activeFiltersFromStore={activeFilters}
                    hasActiveFilters={
                        groupFilterOptions.employees.length ||
                        groupFilterOptions.services.length ||
                        groupFilterOptions.objects.length
                    }
                />
            )}
        </>
    )
};

const Day = ({date, groups}) => {
    const locale = useSelector(state => state.locales.locale);

    const [expanded, setExpanded] = useState(null);

    const onExpandedChange = (group) => (isExpanded) => {
        if (isExpanded) {
            setExpanded(group.id);
        } else {
            setExpanded(null);
        }
    };

    return (
        <div className={Styles.day}>
            <span className={Styles.title} data-testid='data-test-groups-day'>
                {date.locale(locale).calendar(null, {
                    sameDay: 'ddd D MMMM YYYY',
                    nextDay: 'ddd D MMMM YYYY',
                    lastWeek: 'ddd D MMMM YYYY',
                    nextWeek: 'ddd D MMMM YYYY',
                    sameElse: 'ddd D MMMM YYYY'
                })}
            </span>

            {groups.map(group => (
                <ServiceOptions
                    key={`group-${group.id}`}
                    group={group}
                    type={'group'}
                    expanded={expanded === group.id}
                    onExpandChanged={onExpandedChange(group)}
                />
            ))}
        </div>
    )
};

export default Groups;
